/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactEmailResponse
 */
export interface ContactEmailResponse {
    /**
     * 
     * @type {number}
     * @memberof ContactEmailResponse
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ContactEmailResponse
     */
    email?: string;
    /**
     * 
     * @type {Date}
     * @memberof ContactEmailResponse
     */
    modificationDate: Date;
}

export function ContactEmailResponseFromJSON(json: any): ContactEmailResponse {
    return ContactEmailResponseFromJSONTyped(json, false);
}

export function ContactEmailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactEmailResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function ContactEmailResponseToJSON(value?: ContactEmailResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'email': value.email,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


